import clsx from 'clsx'
import type { ReactNode } from 'react'

type Width = 'narrow' | 'regular' | 'wide'

const widthStyles: { [key in Width]: string } = {
  narrow: 'max-w-xl',
  regular: 'max-w-3xl',
  wide: 'max-w-5xl',
}

interface Props {
  children: ReactNode
  className?: string
  width?: Width
}

const AdminFormLayout = ({ children, className, width = 'regular' }: Props) => {
  return <div className={clsx('mt-8', widthStyles[width], className)}>{children}</div>
}

export default AdminFormLayout
